module.exports = __webpack_public_path__ + "img/blog-49.ba1c106d.jpg";